import { motion } from "framer-motion";
import { Reveal, SectionHeader } from "./Reveal";
import { formation } from "../../data/content";

export const Formation = () => (
  <section id="parcours" className="relative py-24 md:py-32 border-t border-white/5">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <SectionHeader index="04" kicker="Formation" title="Mon parcours" italic="académique." />

      <div className="grid lg:grid-cols-12 gap-10">
        {/* Timeline des formations */}
        <div className="lg:col-span-8 space-y-4">
          {formation.parcours.map((f, i) => (
            <Reveal key={i} delay={i * 0.06}>
              <motion.div
                whileHover={{ x: 6 }}
                transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                className="relative bg-surface border border-white/5 rounded-2xl p-7 md:p-8 hover:border-cyan/30 transition-colors duration-400"
                data-testid={`formation-item-${i}`}
              >
                <div className="flex flex-wrap items-baseline justify-between gap-2 mb-3">
                  <div className="flex items-center gap-3">
                    {f.current && <span className="text-[10px] uppercase tracking-[0.25em] text-cyan bg-cyan/10 border border-cyan/30 rounded-full px-2.5 py-1">En cours</span>}
                    <span className="text-sm text-[var(--muted)]">{f.dates}</span>
                  </div>
                  <span className="text-sm text-[var(--muted)]">{f.lieu}</span>
                </div>
                <h3 className="font-display font-medium text-2xl leading-tight">{f.etablissement}</h3>
                <p className="text-cyan/90 mt-1 mb-4">{f.diplome}</p>
                <ul className="space-y-2">
                  {f.details.map((d, j) => (
                    <li key={j} className="text-sm text-[var(--text-2)] flex gap-2">
                      <span className="text-cyan mt-0.5">—</span> {d}
                    </li>
                  ))}
                </ul>
              </motion.div>
            </Reveal>
          ))}
        </div>

        {/* Langues */}
        <Reveal delay={0.1} className="lg:col-span-4">
          <div className="sticky top-24 bg-surface border border-white/5 rounded-2xl p-8">
            <h4 className="text-xs uppercase tracking-[0.2em] text-white/60 mb-6">Langues</h4>
            <div className="space-y-5">
              {formation.langues.map((l, i) => (
                <div key={i} className="flex items-center justify-between border-b border-white/5 pb-4 last:border-0 last:pb-0">
                  <span className="text-white/90">{l.langue}</span>
                  <span className="text-sm text-cyan">{l.niveau}</span>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
